<template>
  <div class="app-container app-page">
    <van-nav-bar :title="$t('my.task_record')" class="app-nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="app-main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')" :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="app-item-list" v-for="(v,key) in list" :key="key">
          <div class="game-records-page__lottery-info">
            <van-image class="app-cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <span class="app-period-number">{{v.data[0].expect}}</span>
            <span class="app-period-number">{{v.name}}</span>
          </div>
          <div class="app-recent">
            <div class="app-dice-ball app-left">
              <template  v-if="$store.getters.getBaseInfo.close_number == 0">
                <van-image class="app-res-img" :src=" v.status === 0 ? '/img/lottery/open_num.gif' : '/img/lottery/shaizi/' + v.opencode[0] + '.png?v=3' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <van-image class="app-res-img" :src=" v.status === 0 ? '/img/lottery/open_num.gif' : '/img/lottery/shaizi/' + v.opencode[1] + '.png?v=3' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <van-image class="app-res-img" :src=" v.status === 0 ? '/img/lottery/open_num.gif' : '/img/lottery/shaizi/' + v.opencode[2] + '.png?v=3' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <!-- <span class="app-res-des middle">{{v.status === 0 ? 0 : v.opencode[0] + v.opencode[1] + v.opencode[2]}}</span> -->
              </template>
              <span class="app-res-des middle" v-if="v.one">{{v.one}}</span>
              <span class="app-res-des middle" v-if="v.two">{{v.two}}</span>
            </div>
          </div>
          <div class="app-top-info">
            <span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
            <span v-else>{{v.status_text}}</span>
          </div>
       <!--   <div class="app-top-info">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>金额：{{v.profit}}</span>
          </div> -->
          <!-- <div class="app-top-info">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
          <div class="app-time game-records-page__top-info-text">
            <span>{{$t("reservation.money")}}：{{v.money}} {{ $t("reservation.unit") }}</span>
          </div>
          <div class="app-time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
          </div>
          <div class="app-time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list:[],
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/auth/login'})
    }else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped src="./GameRecord.styles.less"></style>
